<template>
	<section class="section h-100 d-flex flex-column align-items-center justify-content-center">
		<h1>403</h1>
		<div>Du hast keine Berechtigung, diese Seite aufzurufen.</div>
		<a href="/" class="btn btn-primary mt-2" role="button">Zurück zur Startseite</a>
	</section>
</template>

<script setup lang="ts"></script>
